import React, { FC } from "react";
import clsx from "clsx";
import makeStyles from "@material-ui/core/styles/makeStyles";
import FontIcon from "../../../components/FontIcon";
import { IProduct } from "../types";

const useStyles = makeStyles(() => ({
  root: {
    width: 256,
    backgroundColor: "white",
    borderRadius: 15,
    border: "1px solid #c5c5c54d",
    position: "relative",
    overflow: "hidden",
    transition: "box-shadow .2s,transform .1s ease-in",
  },
  hover: {
    "&:hover": {
      boxShadow: "0px 0px 8px #C2C9D6B3",
      cursor: "pointer",
    },
  },
  selected: {
    transform: "perspective(1px) scale(1.03, 1.03)",

    "&::before": {
      content: '""',
      position: "absolute",
      left: 0,
      top: 0,
      height: 4,
      width: "100%",
      backgroundColor: "#e6c224",
    },
    "&::after": {
      content: '""',
      position: "absolute",
      left: 0,
      bottom: 0,
      height: 4,
      width: "100%",
      backgroundColor: "#e6c224",
    },
  },
  container: {
    padding: "40px 24px 40px 24px",
  },
  name: {
    textAlign: "center",
    fontSize: 20,
    fontWeight: 500,
    color: "#231f20",
    margin: "0 0 24px 0",
  },
  prise: {
    textAlign: "center",
    fontSize: 32,
    color: "#231f20",
    margin: "0 0 24px 0",
  },
  oldPrice: {
    textDecoration: "line-through",
    textAlign: "center",
    fontSize: 24,
    color: " #767676",
    margin: "unset",
  },
  selectedPrise: {
    color: "#e6c224",
  },
  iconTextContainer: {
    display: "flex",
    "& + &": {
      marginTop: 23,
    },
  },
  icon: {
    fontSize: 16,
    color: "#7ec884",
    paddingTop: 1,
    height: 18,
    width: 18,
  },
  text: {
    paddingLeft: 18,
  },
}));

interface IPackageCard {
  product: IProduct;
  selectedPackageId?: number;
  onClick: any;
}

export const PackageCard: FC<IPackageCard> = ({
  product: { id, price, benefits, name, oldPrice },
  selectedPackageId,
  onClick,
}) => {
  const classes = useStyles();
  const isSelected = selectedPackageId === id;

  return (
    <div
      className={clsx(
        classes.root,
        isSelected && classes.selected,
        !isSelected && classes.hover,
      )}
      onClick={() => onClick(id)}
    >
      <div className={classes.container}>
        <p className={classes.name}>{name.toUpperCase()}</p>
        {!!oldPrice && oldPrice !== price && (
          <p className={classes.oldPrice}>${oldPrice}</p>
        )}
        <p className={clsx(classes.prise, isSelected && classes.selectedPrise)}>
          ${price}
        </p>
        {benefits.map((benefit, index) => (
          <div className={classes.iconTextContainer} key={index}>
            <FontIcon name={"feature"} className={classes.icon} />
            <div className={classes.text}>{benefit}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
